var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt015ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.167,
    height: 96.167,
    viewBox: "0 0 96.167 96.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNode-ot-pc-TableauPlaceholder-pc-",
    "data-name": "-ot-pathwayNode-ot-pc-TableauPlaceholder-pc-",
    transform: "translate(-1963 -278.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNodeBackground-ot-pc-TableauPlaceholder-pc-_",
    "data-name": "-ot-pathwayNodeBackground-ot-pc-TableauPlaceholder-pc- ",
    transform: "translate(1963 326.209) rotate(-45)",
    fill: "#edebef",
    stroke: "#241345",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 60,
    height: 60,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_-ot-pathwayNodeIcon-ot-pc-TableauPlaceholder-pc-",
    "data-name": "-ot-pathwayNodeIcon-ot-pc-TableauPlaceholder-pc-"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M0,0H48V48H0Z",
    transform: "translate(1987 302.208)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M146.57,6.814l-.84,1.641h1.93l2.383-4.665,2.382,4.665h1.93L150.043,0Z",
    transform: "translate(1856.667 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M151.3,179.89a4.229,4.229,0,1,0,4.229,4.229A4.229,4.229,0,0,0,151.3,179.89Zm2.469,4.229a2.469,2.469,0,1,1-2.469-2.469,2.469,2.469,0,0,1,2.469,2.469Z",
    transform: "translate(1855.41 142.503)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M148.63,361.542H151.9v6.763h1.722v-6.763h3.271V359.82H148.63Z",
    transform: "translate(1853.947 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M4.216.012,0,0V8.455H4.229A4.139,4.139,0,0,0,7.2,7.211c.085-.084.169-.169.242-.253A4.217,4.217,0,0,0,4.216.012ZM6.684,4.242A2.47,2.47,0,0,1,4.216,6.71H1.748V1.771H4.216A2.47,2.47,0,0,1,6.684,4.239Z",
    transform: "translate(1993.333 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M7.338,183.891a.751.751,0,0,0-.052-.059,2.721,2.721,0,0,0-2.01-.888H2.339a.6.6,0,0,1-.593-.593v-.044a.6.6,0,0,1,.593-.593H7.31V179.94H2.339A2.349,2.349,0,0,0,0,182.293v.047a2.306,2.306,0,0,0,.407,1.327,2.244,2.244,0,0,0,.3.377,2.332,2.332,0,0,0,1.631.66H5.274a.966.966,0,1,1,0,1.932H.259v1.76H5.274a2.725,2.725,0,0,0,2.1-4.462A.413.413,0,0,1,7.338,183.891Z",
    transform: "translate(1993.334 142.457)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M0,364.061A4.247,4.247,0,0,0,4.242,368.3H7.964V366.54H4.242a2.488,2.488,0,0,1-2.314-1.594h4.78V363.18H1.928a2.488,2.488,0,0,1,2.314-1.594H7.964V359.82H4.242A4.247,4.247,0,0,0,0,364.061Z",
    transform: "translate(1993.333 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M299.092,8.455h1.722V1.722h3.271V0H295.82V1.722h3.272Z",
    transform: "translate(1715.912 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M305.849,181.65h3.314v-1.76h-3.314a4.229,4.229,0,0,0,0,8.459h3.314v-1.76h-3.314a2.469,2.469,0,1,1,0-4.938Z",
    transform: "translate(1710.473 142.503)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M296.808,362.6l-2.143-2.779h-2.2l3.318,4.3.163.2v3.987h1.744v-4.011l3.458-4.474H298.95Z",
    transform: "translate(1719.063 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M444.442,0,440.97,6.814l-.84,1.641h1.93l2.382-4.665,2.383,4.665h1.93Z",
    transform: "translate(1580.578 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 1.722,
    height: 8.458,
    transform: "translate(2024.159 322.394)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553",
    "data-name": "Ellipse 553",
    cx: 1.366,
    cy: 1.366,
    r: 1.366,
    transform: "translate(2023.653 333.584)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    cx: 1.366,
    cy: 1.366,
    r: 1.366,
    transform: "translate(2023.653 339.337)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M146.57,6.814l-.84,1.641h1.93l2.383-4.665,2.382,4.665h1.93L150.043,0Z",
    transform: "translate(1856.667 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M151.3,179.89a4.229,4.229,0,1,0,4.229,4.229A4.229,4.229,0,0,0,151.3,179.89Zm2.469,4.229a2.469,2.469,0,1,1-2.469-2.469,2.469,2.469,0,0,1,2.469,2.469Z",
    transform: "translate(1855.41 142.503)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M148.63,361.542H151.9v6.763h1.722v-6.763h3.271V359.82H148.63Z",
    transform: "translate(1853.947 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M4.216.012,0,0V8.455H4.229A4.139,4.139,0,0,0,7.2,7.211c.085-.084.169-.169.242-.253A4.217,4.217,0,0,0,4.216.012ZM6.684,4.242A2.47,2.47,0,0,1,4.216,6.71H1.748V1.771H4.216A2.47,2.47,0,0,1,6.684,4.239Z",
    transform: "translate(1993.333 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M7.338,183.891a.751.751,0,0,0-.052-.059,2.721,2.721,0,0,0-2.01-.888H2.339a.6.6,0,0,1-.593-.593v-.044a.6.6,0,0,1,.593-.593H7.31V179.94H2.339A2.349,2.349,0,0,0,0,182.293v.047a2.306,2.306,0,0,0,.407,1.327,2.244,2.244,0,0,0,.3.377,2.332,2.332,0,0,0,1.631.66H5.274a.966.966,0,1,1,0,1.932H.259v1.76H5.274a2.725,2.725,0,0,0,2.1-4.462A.413.413,0,0,1,7.338,183.891Z",
    transform: "translate(1993.334 142.457)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M0,364.061A4.247,4.247,0,0,0,4.242,368.3H7.964V366.54H4.242a2.488,2.488,0,0,1-2.314-1.594h4.78V363.18H1.928a2.488,2.488,0,0,1,2.314-1.594H7.964V359.82H4.242A4.247,4.247,0,0,0,0,364.061Z",
    transform: "translate(1993.333 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M299.092,8.455h1.722V1.722h3.271V0H295.82V1.722h3.272Z",
    transform: "translate(1715.912 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M305.849,181.65h3.314v-1.76h-3.314a4.229,4.229,0,0,0,0,8.459h3.314v-1.76h-3.314a2.469,2.469,0,1,1,0-4.938Z",
    transform: "translate(1710.473 142.503)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M296.808,362.6l-2.143-2.779h-2.2l3.318,4.3.163.2v3.987h1.744v-4.011l3.458-4.474H298.95Z",
    transform: "translate(1719.063 -26.235)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M444.442,0,440.97,6.814l-.84,1.641h1.93l2.382-4.665,2.383,4.665h1.93Z",
    transform: "translate(1580.578 311.205)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 1.722,
    height: 8.458,
    transform: "translate(2024.159 322.394)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 1.366,
    cy: 1.366,
    r: 1.366,
    transform: "translate(2023.653 333.584)",
    fill: "#241345"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 1.366,
    cy: 1.366,
    r: 1.366,
    transform: "translate(2023.653 339.337)",
    fill: "#241345"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt015ColorDiamond);
export default __webpack_public_path__ + "static/media/PT015_color_diamond.7d3ecddc89789aafeb3337e75f3aff64.svg";
export { ForwardRef as ReactComponent };